
import React from 'react';
import { Navbar } from '@/components/ui/navbar';
import { AppSidebar } from '@/components/navigation/AppSidebar';
import { Footer } from '@/components/ui/footer';
import { HelpAssistant } from '@/components/help/components/HelpAssistant';
import { cn } from '@/lib/utils';
import { useDevice } from '@/hooks/use-device';
import { useSidebar } from '@/components/ui/sidebar/context';
import { motion } from 'framer-motion';
import { ResponsiveLayoutProvider } from './ResponsiveLayoutProvider';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const { isMobile, isTablet } = useDevice();
  const { open } = useSidebar();
  
  return (
    <ResponsiveLayoutProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className={cn(
          "flex-1 flex flex-col min-h-screen",
          "bg-gradient-to-b from-amber-50/50 to-white",
          "transition-all duration-300 ease-in-out",
          "overflow-x-hidden",
          isMobile && "pb-16",
          isTablet && "pb-0",
          open ? "md:pl-[280px]" : "md:pl-[60px]"
        )}>
          <Navbar />
          <motion.main 
            className={cn(
              "flex-1 w-full max-w-full",
              isMobile && "px-2",
              isTablet && "px-4",
              "md:px-6"
            )}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.main>
          <Footer />
        </div>
        {!isMobile && <HelpAssistant />}
      </div>
    </ResponsiveLayoutProvider>
  );
}
